// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8d12045d","455":"95a7db7c","977":"a1b6c7af"}[chunkId] + ".chunk.js";
};